import { initializeRecord } from "../../helpers/helpers";
import { genomeOptions } from "../../constants";

const g = Object.keys(genomeOptions);

const initialState = {
    position: initializeRecord(g, 25),
    width: initializeRecord(g, 50),
    repeatSelection: initializeRecord(g, []),
    geneSelection: initializeRecord(g, []),
    methylationSelection: initializeRecord(g, []),
    repeatStart: initializeRecord(g, ""),
    repeatEnd: initializeRecord(g, "")
};

export const changeSliderRepeatSelection = (newValue) => {
    return {
        type: "slider/sliderRepeatSelection",
        payload: newValue
    };
}

export const changeSliderGeneSelection = (newValue) => {
    return {
        type: "slider/sliderGeneSelection",
        payload: newValue
    };
}

export const changeSliderMethylationSelection = (newValue) => {
    return {
        type: "slider/sliderMethylationSelection",
        payload: newValue
    };
}

export const changeSliderPosition = (newValue) => {
    return {
        type: "slider/sliderPosition",
        payload: newValue
    };
}

export const changeSliderWidth = (newValue) => {
    return {
        type: "slider/sliderWidth",
        payload: newValue
    };
}

export const changeRepeatStart = (newValue) => {
    return {
        type: "slider/repeatStart",
        payload: newValue
    };
}

export const changeRepeatEnd = (newValue) => {
    return {
        type: "slider/repeatEnd",
        payload: newValue
    };
}
export const sliderReducer = (state = initialState, action) => { 
    switch(action.type) {
        case "slider/sliderRepeatSelection":
            return {
                ...state,
                repeatSelection: {
                    ...state["repeatSelection"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/sliderGeneSelection":
            return {
                ...state,
                geneSelection: {
                    ...state["geneSelection"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/sliderPosition":
            return {
                ...state,
                position: {
                    ...state["position"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/sliderWidth":
            return {
                ...state,
                width: {
                    ...state["width"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/sliderMethylationSelection":
            return {
                ...state,
                methylationSelection: {
                    ...state["methylationSelection"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/repeatStart":
            return {
                ...state,
                repeatStart: {
                    ...state["repeatStart"],
                    [action.payload.key]: action.payload.value
                }
            };
        case "slider/repeatEnd":
            return {
                ...state,
                repeatEnd: {
                    ...state["repeatEnd"],
                    [action.payload.key]: action.payload.value
                }
            };
        default:
            return state;
    };
}